// extracted by mini-css-extract-plugin
export default {"pwa-button":"PWAButton__pwa-button__T0xPP","pwaButton":"PWAButton__pwa-button__T0xPP"};